module.exports = __webpack_public_path__ + "img/logo_background_blue.b08b4802.svg";